/**
 * File: maApp.validation.module.js
 */
(function(){
    angular
        .module('maApp.validation', []);
})();